import { mapGetters } from 'vuex'
import accessHelper from 'helpers/accessHelper'
import { Converter } from 'showdown'
import { textFormatter } from 'store/shared/chatBotHelper'

export default {
    computed: {
        ...mapGetters({
            userPackages: 'User/getPackageInfo'
        }),
        packagesWithAccessLevel () {
            return this.userPackages.filter(packageItem => packageItem.accessLevel >= accessHelper.ACCESS_LEVEL_FULL)
        }
    },
    methods: {
        getRecommendedMessageLink (response) {
            let coursesTemplate = ``
            if (response.relatedContent.relatedCourses.length > 0 || response.relatedContent.relatedLearningPaths.length > 0) {
                coursesTemplate += `<br><div class="course-links-container" id="course-links-container_${response.id}">`
            }
            if (response.relatedContent.relatedCourses.length > 0) {
                response.relatedContent.relatedCourses.forEach(course => {
                    coursesTemplate += `
                        <div class="course-link" id="${course.courseId}">
                            <img id="${course.courseId}" class="course-link-icon" src="${this.linkImage}" />
                            <span class="course-link-text" id="${course.courseId}">${course.title}</span>
                        </div>
                        `
                })
            }
            if (response.relatedContent.relatedLearningPaths.length > 0) {
                response.relatedContent.relatedLearningPaths.forEach(learningPath => {
                    coursesTemplate += `
                        <div class="learningpath-link" id="${learningPath.learningPathId}">
                            <img id="${learningPath.learningPathId}" class="course-link-icon" src="${this.linkImage}" />
                            <span class="course-link-text" id="${learningPath.learningPathId}">${learningPath.name}</span>
                        </div>
                        `
                })
            }
            if (response.relatedContent.relatedCourses.length > 0 || response.relatedContent.relatedLearningPaths.length > 0) {
                coursesTemplate += `</div>`
            }
            return coursesTemplate
        },
        async streamSimulation (response) {
            const shadowRoot = this.$refs.chatbot.shadowRoot
            const messageContainer = shadowRoot.getElementById(`message_${response.id}`)
            const courseLinksContainer = shadowRoot.getElementById(`course-links-container_${response.id}`)
            const feedbackContainer = shadowRoot.getElementById(`feedback-container_${response.id}`)

            this.setStyle(messageContainer, {
                whiteSpace: 'pre-line',
                height: 'inherit',
            })

            this.setStyle(courseLinksContainer, {
                display: 'none',
                transition: 'all 0.3s ease-in-out',
                opacity: 0
            })
            this.setStyle(feedbackContainer, {
                'justify-content': 'flex-end',
                gap: '7px',
                display: 'none',
                transition: 'all 0.3s ease-in-out',
                opacity: 0
            })
            this.typeCharacters(response.content, messageContainer, courseLinksContainer, feedbackContainer)
        },
        getCurrentTimeStamp () {
            return Date.now()
        },
        type (text, index, characterCountToType, messageContainer) {
            if (index < text.length) {
                let charactersToType = text.substring(index, index + characterCountToType)
                messageContainer.innerHTML += charactersToType
            }
        },
        typeCharacters (text, messageContainer, courseLinksContainer, feedbackContainer) {
            let speed = 25
            let index = 0
            let lastCall = this.getCurrentTimeStamp()
            let minCharacterCountToType = 3

            let intervalId = setInterval(() => {
                let currentTime = this.getCurrentTimeStamp()
                let deltaTime = currentTime - lastCall

                let characterCountToType = Math.floor(speed * (deltaTime / 1000))
                characterCountToType = Math.max(characterCountToType, minCharacterCountToType)
                if (characterCountToType > 0) {
                    this.type(text, index, characterCountToType, messageContainer)
                    index += characterCountToType
                    lastCall = currentTime
                }

                this.scrollChatToBottom()

                if (index >= text.length) {
                    clearInterval(intervalId)
                    this.finishStreamingSimulation(courseLinksContainer, feedbackContainer, messageContainer)
                }
            }, 1000 / speed)
        },
        setStyle (element, styles) {
            if (element) {
                Object.assign(element.style, styles)
            }
        },
        finishStreamingSimulation (courseLinksContainer, feedbackContainer, messageContainer) {

            messageContainer.innerHTML = textFormatter(messageContainer.innerHTML)
            this.setStyle(messageContainer, {
                whiteSpace: 'normal'
            })
            this.scrollChatToBottom()
            this.setStyle(courseLinksContainer, { display: 'inline-block' })
            this.setStyle(feedbackContainer, { display: 'flex' })
            setTimeout(async () => {
                this.scrollChatToBottom()
                this.setStyle(courseLinksContainer, { opacity: 1 })
                this.setStyle(feedbackContainer, { opacity: 1 })
            }, 500)
        },
        createSuggestionButtons () {
            const suggestions = this.getSetQuestionSetBasedOnUserPackages()
            const suggestionButtonsHTML = []
            suggestions.forEach((suggestion) => {
                suggestionButtonsHTML.push(`
                    <button style="opacity: 0;" class="deep-chat-button deep-chat-suggestion-button">
                        ${suggestion.text}
                        <img class="suggestion-icon-link" src="${suggestion.icon}" />
                    </button>
                `)
            })
            const suggestionButtonsContainerHTML = `
                <div class="suggestion-buttons deep-chat-temporary-message">
                    <span>${this.$t('Chatbot.suggestion_buttons_message')}</span>
                    ${suggestionButtonsHTML.join('')}
                </div>
            `
            this.$refs.chatbot.initialMessages = [
                {
                    html: suggestionButtonsContainerHTML,
                    role: 'suggestion'
                }
            ]
            const shadowRoot = this.$refs.chatbot.shadowRoot
            const keyframes = `
                    @keyframes fadeIn {
                        from {
                            opacity: 0;
                            transform: translateY(-20px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                `
            const style = document.createElement('style')
            style.textContent = keyframes
            shadowRoot.appendChild(style)
            setTimeout(() => {
                const shadowRoot = this.$refs.chatbot.shadowRoot
                const suggestionButtons = shadowRoot.querySelectorAll('.deep-chat-suggestion-button')
                suggestionButtons.forEach((button, index) => {
                    button.style.animation = 'fadeIn 0.5s ease-out forwards'
                    button.style.animationDelay = `${index * 0.1}s`
                })
            }, 500)
        },
        getRandomStrings (stringArray) {
            let uniqueStrings = [...new Set(stringArray)]
            let shuffled = uniqueStrings.sort(() => 0.5 - Math.random())
            return shuffled.slice(0, 3).map(string => ({
                text: this.$t(string),
                icon: this.suggestionIcon
            }))
        },
        getSetQuestionSetBasedOnUserPackages () {
            let selectedStrings = []
            let packageStrings = null
            if (this.$totemLang === 'fi') {
                packageStrings = {
                    'fi-digiskills, fi-o365-p': ['Chatbot.examplequestions_digiskills_1', 'Chatbot.examplequestions_digiskills_2', 'Chatbot.examplequestions_digiskills_3', 'Chatbot.examplequestions_digiskills_4', 'Chatbot.examplequestions_digiskills_5'],
                    'fi-cloudskills, fi-cloudpro': ['Chatbot.examplequestions_cloudskills_1', 'Chatbot.examplequestions_cloudskills_2', 'Chatbot.examplequestions_cloudskills_3', 'Chatbot.examplequestions_cloudskills_4', 'Chatbot.examplequestions_cloudskills_5', 'Chatbot.examplequestions_cloudskills_6', 'Chatbot.examplequestions_cloudskills_7', 'Chatbot.examplequestions_cloudskills_8', 'Chatbot.examplequestions_cloudskills_9'],
                    'fi-public, fi-julkishallinto': ['Chatbot.examplequestions_public_1', 'Chatbot.examplequestions_public_3', 'Chatbot.examplequestions_public_5', 'Chatbot.examplequestions_public_7', 'Chatbot.examplequestions_public_8', 'Chatbot.examplequestions_public_10', 'Chatbot.examplequestions_public_11', 'Chatbot.examplequestions_public_13'],
                    'fi-tietoturva': ['Chatbot.examplequestions_cybersecurity_1', 'Chatbot.examplequestions_cybersecurity_2', 'Chatbot.examplequestions_cybersecurity_3'],
                    'fi-tekoäly': ['Chatbot.examplequestions_ai_1', 'Chatbot.examplequestions_ai_2', 'Chatbot.examplequestions_ai_3'],
                    'fi-powerskills': ['Chatbot.examplequestions_powerskills_1', 'Chatbot.examplequestions_powerskills_2', 'Chatbot.examplequestions_powerskills_5', 'Chatbot.examplequestions_powerskills_6'],
                    'fi-myynti, fi-myynti-2': ['Chatbot.examplequestions_sales_and_customer_experience_1', 'Chatbot.examplequestions_sales_and_customer_experience_2', 'Chatbot.examplequestions_sales_and_customer_experience_3', 'Chatbot.examplequestions_sales_and_customer_experience_4', 'Chatbot.examplequestions_sales_and_customer_experience_5', 'Chatbot.examplequestions_sales_and_customer_experience_6'],
                    'fi-hr-p, fi-pht-valmennus': ['Chatbot.examplequestions_hr_payroll_1', 'Chatbot.examplequestions_hr_payroll_2', 'Chatbot.examplequestions_hr_payroll_3', 'Chatbot.examplequestions_hr_payroll_4'],
                    'fi-johtaminen, fi-esimies': ['Chatbot.examplequestions_management_1', 'Chatbot.examplequestions_management_2', 'Chatbot.examplequestions_management_3', 'Chatbot.examplequestions_management_4', 'Chatbot.examplequestions_management_5', 'Chatbot.examplequestions_management_6', 'Chatbot.examplequestions_management_7'],
                    'fi-oppilaitos': ['Chatbot.examplequestions_business_basics_1', 'Chatbot.examplequestions_business_basics_2', 'Chatbot.examplequestions_business_basics_3', 'Chatbot.examplequestions_business_basics_4', 'Chatbot.examplequestions_business_basics_5'],
                    'fi-talous, fi-klt-valmennus': ['Chatbot.examplequestions_finance_and_tax_1', 'Chatbot.examplequestions_finance_and_tax_2', 'Chatbot.examplequestions_finance_and_tax_3', 'Chatbot.examplequestions_finance_and_tax_4'],
                    'fallback': ['Chatbot.examplequestions_fallback_1', 'Chatbot.examplequestions_fallback_2', 'Chatbot.examplequestions_fallback_3']
                }
            } else if (this.$totemLang === 'no') {
                packageStrings = {
                    'no-okonomikurs': ['Chatbot.examplequestions_no_okonomikurs_1', 'Chatbot.examplequestions_no_okonomikurs_2', 'Chatbot.examplequestions_no_okonomikurs_3', 'Chatbot.examplequestions_no_okonomikurs_4', 'Chatbot.examplequestions_no_okonomikurs_5', 'Chatbot.examplequestions_no_okonomikurs_6', 'Chatbot.examplequestions_no_okonomikurs_7', 'Chatbot.examplequestions_no_okonomikurs_8', 'Chatbot.examplequestions_no_okonomikurs_9', 'Chatbot.examplequestions_no_okonomikurs_10'],
                    'no-personligutvikling': ['Chatbot.examplequestions_no_personligutvikling_1', 'Chatbot.examplequestions_no_personligutvikling_2', 'Chatbot.examplequestions_no_personligutvikling_3', 'Chatbot.examplequestions_no_personligutvikling_4', 'Chatbot.examplequestions_no_personligutvikling_5', 'Chatbot.examplequestions_no_personligutvikling_6'],
                    'no-o365': ['Chatbot.examplequestions_no_o365_1', 'Chatbot.examplequestions_no_o365_2', 'Chatbot.examplequestions_no_o365_3', 'Chatbot.examplequestions_no_o365_4', 'Chatbot.examplequestions_no_o365_5', 'Chatbot.examplequestions_no_o365_6', 'Chatbot.examplequestions_no_o365_7'],
                    'no-management': ['Chatbot.examplequestions_no_management_1', 'Chatbot.examplequestions_no_management_2', 'Chatbot.examplequestions_no_management_3', 'Chatbot.examplequestions_no_management_4', 'Chatbot.examplequestions_no_management_5', 'Chatbot.examplequestions_no_management_6'],
                    'no-list-acab,  no-list-agratis,  no-list-regn': ['Chatbot.examplequestions_no_random_1', 'Chatbot.examplequestions_no_random_2', 'Chatbot.examplequestions_no_random_3', 'Chatbot.examplequestions_no_random_4', 'Chatbot.examplequestions_no_random_5', 'Chatbot.examplequestions_no_random_6'],
                    'fallback': ['Chatbot.examplequestions_no_fallback_1', 'Chatbot.examplequestions_no_fallback_2', 'Chatbot.examplequestions_no_fallback_3']
                }
            } else if (this.$totemLang === 'se') {
                packageStrings = {
                    'se-skatt-moms': ['Chatbot.examplequestions_se_skatt_moms_1', 'Chatbot.examplequestions_se_skatt_moms_2', 'Chatbot.examplequestions_se_skatt_moms_3', 'Chatbot.examplequestions_se_skatt_moms_4', 'Chatbot.examplequestions_se_skatt_moms_5', 'Chatbot.examplequestions_se_skatt_moms_6'],
                    'se-redovisning': ['Chatbot.examplequestions_se_redovisning_1', 'Chatbot.examplequestions_se_redovisning_2', 'Chatbot.examplequestions_se_redovisning_3', 'Chatbot.examplequestions_se_redovisning_4', 'Chatbot.examplequestions_se_redovisning_5', 'Chatbot.examplequestions_se_redovisning_6', 'Chatbot.examplequestions_se_redovisning_7', 'Chatbot.examplequestions_se_redovisning_8'],
                    'se-office-skills,  se-o365': ['Chatbot.examplequestions_se_office_skills_1', 'Chatbot.examplequestions_se_office_skills_2', 'Chatbot.examplequestions_se_office_skills_3', 'Chatbot.examplequestions_se_office_skills_4', 'Chatbot.examplequestions_se_office_skills_5', 'Chatbot.examplequestions_se_office_skills_6', 'Chatbot.examplequestions_se_office_skills_7'],
                    'se-hr': ['Chatbot.examplequestions_se_hr_1', 'Chatbot.examplequestions_se_hr_2', 'Chatbot.examplequestions_se_hr_3'],
                    'se-ledarskap': ['Chatbot.examplequestions_se_ledarskap_1', 'Chatbot.examplequestions_se_ledarskap_2', 'Chatbot.examplequestions_se_ledarskap_3', 'Chatbot.examplequestions_se_ledarskap_4', 'Chatbot.examplequestions_se_ledarskap_5', 'Chatbot.examplequestions_se_ledarskap_6'],
                    'se-lon': ['Chatbot.examplequestions_se_lon_1', 'Chatbot.examplequestions_se_lon_2', 'Chatbot.examplequestions_se_lon_3', 'Chatbot.examplequestions_se_lon_4'],
                    'se-design': ['Chatbot.examplequestions_se_design_1', 'Chatbot.examplequestions_se_design_2', 'Chatbot.examplequestions_se_design_3'],
                    'se-annat, se-list-a, se-list-agroup, se-list-redov,  se-valbefinnande': ['Chatbot.examplequestions_se_random_1', 'Chatbot.examplequestions_se_random_2', 'Chatbot.examplequestions_se_random_3', 'Chatbot.examplequestions_se_random_4', 'Chatbot.examplequestions_se_random_5', 'Chatbot.examplequestions_se_random_6', 'Chatbot.examplequestions_se_random_7', 'Chatbot.examplequestions_se_random_8', 'Chatbot.examplequestions_se_random_9', 'Chatbot.examplequestions_se_random_10', 'Chatbot.examplequestions_se_random_11', 'Chatbot.examplequestions_se_random_12'],
                    'fallback': ['Chatbot.examplequestions_se_fallback_1', 'Chatbot.examplequestions_se_fallback_2', 'Chatbot.examplequestions_se_fallback_3']
                }
            }

            let questions = []
            this.packagesWithAccessLevel.forEach(userPackage => {
                Object.keys(packageStrings).forEach(packageCode => {
                    let codes = packageCode.split(', ').map(code => code.trim())
                    if (codes.includes(userPackage.code)) {
                        questions = questions.concat(packageStrings[packageCode])
                    }
                })
            })
            selectedStrings = questions.length ? this.getRandomStrings(questions) : this.getRandomStrings(packageStrings['fallback'])
            return selectedStrings
        },
    }
}
